'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = require('react');

module.exports = function (props) {
  var _props$size = props.size,
      size = _props$size === undefined ? 16 : _props$size,
      _props$spokes = props.spokes,
      spokes = _props$spokes === undefined ? 8 : _props$spokes,
      _props$duration = props.duration,
      duration = _props$duration === undefined ? 1000 : _props$duration,
      rest = _objectWithoutProperties(props, ['size', 'spokes', 'duration']);

  return React.createElement(
    'svg',
    _extends({
      viewBox: '0 0 32 32',
      width: size,
      height: size,
      style: style,
      fill: 'currentcolor'
    }, rest),
    getPaths(spokes, duration)
  );
};

var getPaths = function getPaths(length, dur) {
  return Array.from({ length: length }).map(function (n, i) {
    return React.createElement(
      'path',
      {
        key: i,
        opacity: 0.1,
        d: 'M14 0 H18 V8 H14z',
        transform: 'rotate(' + i * 360 / length + ' 16 16)'
      },
      React.createElement('animate', {
        attributeName: 'opacity',
        from: 1,
        to: 0.1,
        dur: dur + 'ms',
        repeatCount: 'indefinite',
        begin: i * dur / length + 'ms'
      })
    );
  });
};

var style = {
  display: 'inline-flex',
  margin: 0
};